import React, {Component} from 'react';
import InnerHeaderBar from '../../shared/InnerHeaderBar/InnerHeaderBar';
import ProjectsList from './ProjectsList/ProjectsList';
import Message from './Message/Message';
import ToolkitValidationMessage from './ToolkitValidationMessage/ToolkitValidationMessage';
import './Toolkit.css';

class Toolkit extends Component {
    constructor(props) {
      super(props);
      this.defaultParams = {};
      this.state = {
        projectAddedForParens: false,
        toolkitValidationModal: false,
        toolkitDataChanged: false,
        toolkitValidationType: null,
      };
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.createdProjectData.statusCode &&  !this.state.projectAddedForParens ){
            this.setState({projectAddedForParens : true})
        }

        if( nextProps.validationData.statusCode === 200 && !this.state.toolkitDataChanged) {
            this.setState({ toolkitDataChanged : true, toolkitValidationModal: false });
        }
    }

    addedNewProjectState = () => {
        this.setState({projectAddedForParens : false});
    }

    toolkitsValidation = (projectId, parentData, toolkitType) => {

        parentData[0].projectId = projectId
        if(parentData[1]){
            parentData[1].projectId = projectId
        }

        this.setState({toolkitValidationModal : true, toolkitValidationType: toolkitType ,projectId: projectId })

        this.props.toolkitValidation(parentData);
    }

    closeToolkitsValidationt = () => {
        this.setState({toolkitValidationModal : false, toolkitValidationType: null });
        this.props.resetToolkitValidation();
    }
    componentWillUnmount(){
        this.props.resetToolkitValidation();
    }


    render() {
        return(
            <div className='projects-content'>
                <InnerHeaderBar
                    title=''
                    addNewProject={true}
                    createProject={this.props.createProject}
                    createdProjectFetching={this.props.createdProjectFetching}
                    createdProjectData={this.props.createdProjectData}
                    getProjectsList={this.props.getProjectsList}
                    addedNewProjectState={this.addedNewProjectState}
                />

                <div className='container-fluid'>
                  <div className="row">
                    <div className="col-sm-12">
                        <p className="tool-title-p">Click on the “+” sign to start a new marketing plan project</p>
                    </div>
                  </div>
                    <div className="row">
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <ProjectsList
                                        fetching={this.props.fetching}
                                        projectsList={this.props.projectsList}
                                        deleteProject={this.props.deleteProject}
                                        deleteData={this.props.deleteData}
                                        getProjectsList={this.props.getProjectsList}
                                        dublicateProject={this.props.dublicateProject}
                                        dublicateData={this.props.dublicateData}
                                        createdProjectData={this.props.createdProjectData}
                                        projectAddedForParens={this.state.projectAddedForParens}
                                        resetCreateProject={this.props.resetCreateProject}
                                        resetDeleteProject={this.props.resetDeleteProject}
                                        toolkitsValidation={this.toolkitsValidation}
                                        toolkitDataChanged={this.state.toolkitDataChanged}
                                        toolkitValidationType={this.state.toolkitValidationType}
                                        projectId={this.state.projectId}
                                        createProject={this.props.createProject}
                                        createdProjectFetching={this.props.createdProjectFetching}
                                        createdProjectData={this.props.createdProjectData}
                                        getProjectsList={this.props.getProjectsList}
                                        addedNewProjectState={this.addedNewProjectState}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.toolkitValidationModal &&
                    <ToolkitValidationMessage
                        validationFetching={this.props.validationFetching}
                        validationData={this.props.validationData}
                        closeToolkitsValidationt={this.closeToolkitsValidationt}
                    />
                }

                <Message/>
            </div>
        )
    }
}

export default (Toolkit);



// WEBPACK FOOTER //
// ./src/components/Toolkit/Toolkit.jsx